var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoErp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2fs4k88q8a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15382",
    transform: "translate(847 1477)",
    style: {
      fill: "#ff1010",
      opacity: 0.43
    },
    d: "M0 0h120v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 678",
    transform: "translate(-847 -1477)",
    style: {
      clipPath: "url(#2fs4k88q8a)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15378",
    width: 110,
    height: 79.562,
    rx: 5,
    transform: "translate(852 1490)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 65",
    transform: "translate(901.753 1569.561)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0v13.976"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 66",
    transform: "translate(912.247 1569.561)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0v13.976"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 67",
    transform: "translate(884.42 1584.395)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h45.159"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 68",
    transform: "translate(852 1553.65)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h110"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 69",
    transform: "translate(901.753 1569.561)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0v13.976"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 70",
    transform: "translate(912.247 1569.561)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0v13.976"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 71",
    transform: "translate(884.42 1584.395)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h45.159"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 72",
    transform: "translate(852 1553.65)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h110"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59469",
    d: "M24.6 26.928a2.666 2.666 0 1 1-3.689-.784 2.67 2.67 0 0 1 3.689.784",
    transform: "translate(884.632 1533.225)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15384",
    style: {
      stroke: "#4cbbb8",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h6v26H0z",
    transform: "translate(863 1517)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-1-1h8v28h-8z",
    transform: "translate(863 1517)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15385",
    style: {
      stroke: "#4cbbb8",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h6v17H0z",
    transform: "translate(877 1526)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-1-1h8v19h-8z",
    transform: "translate(877 1526)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15386",
    style: {
      stroke: "#4cbbb8",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h6v10H0z",
    transform: "translate(891 1533)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M-1-1h8v12h-8z",
    transform: "translate(891 1533)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59470",
    d: "M7187 19512.2h66.759l5.461 5.461h37.432",
    transform: "translate(-6335 -18012.195)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 84",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(931 1496)",
    style: {
      fill: "#4cbbb8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 85",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(940 1496)",
    style: {
      fill: "#4cbbb8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 86",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(949 1496)",
    style: {
      fill: "#4cbbb8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 73",
    transform: "translate(917.291 1517.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h2.209"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 74",
    transform: "translate(925 1518.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h26.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 73",
    transform: "translate(917.291 1526.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h2.209"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 74",
    transform: "translate(925 1526.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h26.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 73",
    transform: "translate(917.291 1534.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h2.209"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 74",
    transform: "translate(925 1534.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h26.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 73",
    transform: "translate(917.291 1542.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h2.209"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 74",
    transform: "translate(925 1542.5)",
    style: {
      strokeLinecap: "round",
      strokeWidth: 2,
      stroke: "#fff",
      fill: "none"
    },
    d: "M0 0h26.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoErp);
export default __webpack_public_path__ + "static/media/ico_erp.50d287cd6239fa80147c52d938018cc8.svg";
export { ForwardRef as ReactComponent };